import {applySpecialNikud} from './specialNikud'

export function getStandardLetterArray(chosenWordString) {
  return chosenWordString.split(/(?=["'א-ת])/)
}

export function getChosenWordString(wordObj) {
  return wordObj.choiceType === 'option' ? wordObj.options[wordObj.chosenOptionIndex].displayText
          : (wordObj.choiceType === 'manual' ? wordObj.manualNikud : wordObj.editedNikud)
}

export function assignChosenStringLetterArrayAndSpecialNikud (wordObj, stateForOptions) {
  wordObj['chosenWordString'] = getChosenWordString(wordObj)
  // console.log("wordObj['chosenWordString']:")
  // console.log(wordObj['chosenWordString'])
  wordObj['standardLetterArray'] = getStandardLetterArray(wordObj.chosenWordString)
  const specialNikudChanges = applySpecialNikud(stateForOptions, 'letter-array-assignment', wordObj)
  // console.log('specialNikudChanges:')
  // console.log(specialNikudChanges)
  if (specialNikudChanges.mainWord.standardLetterArrayVariants) {
    wordObj['displayVariants'] = specialNikudChanges.mainWord.standardLetterArrayVariants
  }
  if (specialNikudChanges.mainWord.optionVariants) wordObj.options.forEach((opt, o) => {
    Object.keys(specialNikudChanges.mainWord.optionVariants).forEach(k => {
      if (!(opt.hasOwnProperty('displayVariants'))) opt.displayVariants = {}
      opt['displayVariants'][k] = specialNikudChanges.mainWord.optionVariants[k][o]
    })
  })
}
